import { getDimensionById } from "@/lib/dimensions";
import { DimensionId } from "@/types/questionnaries";
import { FC } from "react";

type DimensionIconProps = {
  dimensionId: DimensionId;
};

const DimensionIcon: FC<DimensionIconProps> = (props) => {
  const dimension = getDimensionById(props.dimensionId);

  return (
    dimension && (
      <div
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white"
        style={{ background: dimension.color }}
      >
        <dimension.icon size={20} />
      </div>
    )
  );
};

export default DimensionIcon;
